import axios from "axios"
import { saveAs } from "file-saver"

const base = "/api/competitions/manage"
const options = () => ({ headers: { Authorization: localStorage.getItem("token") } })
const url = (slug) => `${base}/${encodeURIComponent(slug)}`

export default {
  list: () => axios.get(base, options()).then((res) => res.data),
  save: (config) => axios.put(url(config.slug), config, options()).then((res) => res.data),
  entries: (slug, page) => axios.get(`${url(slug)}/entries`, { ...options(), params: { page } }).then((res) => res.data),
  async download(slug, type) {
    try {
      const { data } = await axios.get(`${url(slug)}/${type}`, { ...options(), responseType: "blob" })
      saveAs(data, type === "qr" ? `qr-${slug}.svg` : `wettbewerb-${slug}.xlsx`)
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try { error.response.data = JSON.parse(await error.response.data.text()) } catch (_) { /* Retain the original error. */ }
      }
      throw error
    }
  },
}
